initBeforeAfter();

function initBeforeAfter() {
  const sliders = document.querySelectorAll("[data-before-after]");

  sliders.forEach((slider) => {
    const range = slider.querySelector("[data-before-after-range]");
    if (!range) return;

    const update = () => {
      slider.style.setProperty("--split", `${range.value}%`);
    };

    range.addEventListener("input", update);
    range.addEventListener("change", update);
    update();
  });
}
